import { ConnectLinksDTO } from './types/ConnectLinksDTO';

// eslint-disable-next-line import/no-mutable-exports
const connectLinks: ConnectLinksDTO = {
  connectionLink: '',
  disconnectionLink: '',
};

export const updateLinks = (newLinks: ConnectLinksDTO): void => {
  connectLinks.connectionLink = newLinks.connectionLink;
  connectLinks.disconnectionLink = newLinks.disconnectionLink;
};

export const getLinks = (): ConnectLinksDTO => connectLinks;
